module.exports = __webpack_public_path__ + "img/pp11.079a0c4a.png";